import { parseDateOnly, startOfDay, formatRenewalDate, createRenewalHelpers } from './renewalReportHelpers';

export { parseDateOnly, startOfDay, formatRenewalDate };

const renewal = createRenewalHelpers('completed_by_date');

export const inspectionExpiresOnIso = renewal.inspectionExpiresOnIso;
export const inspectionExpiresOn = renewal.inspectionExpiresOn;
export const getEarliestAllowedCompletedByDate = renewal.getEarliestAllowedDate;
export const reportStatus = renewal.reportStatus;
export const isCompletedByDateAllowed = renewal.isDateAllowed;
export const completedByDateRenewalError = renewal.dateRenewalError;

export const canCreateNewInspectionReport = (reports, referenceDate) => {
  const result = renewal.canCreateNewInspectionReport(reports, referenceDate);
  return {
    allowed: result.allowed,
    earliestAllowedCompletedByDate: result.earliestAllowedDate,
    message: result.message,
  };
};

// Frontend mirror of the backend's Location#storage_inspection_valid? — a completed report whose expiry hasn't passed.
export const isStorageFacilityInspectionValid = (location, referenceDate = new Date()) => {
  const reports = location?.storage_facility_inspection_reports || [];
  const today = startOfDay(referenceDate);

  return reports.some((report) => {
    if (report.status !== 'completed') return false;

    const expiresOn = parseDateOnly(inspectionExpiresOn(report));
    return !!expiresOn && expiresOn >= today;
  });
};

const STORAGE_FEATURE_NOTICE = 'the storage feature will not work for this location until this is resolved.';

export const getInspectionAttentionStatus = (reports, referenceDate = new Date()) =>
  renewal.getInspectionAttentionStatus(reports, referenceDate, {
    draftAwaiting: `A storage inspection form is awaiting completion — ${STORAGE_FEATURE_NOTICE}`,
    noCompleted: `No storage inspection form has been added — ${STORAGE_FEATURE_NOTICE}`,
    expired: `The storage inspection has expired — ${STORAGE_FEATURE_NOTICE}`,
    renewalDue: `The storage inspection is expiring soon — renew it to keep the storage feature working.`,
  });
